/**
 * Removes all empty strings from an array of strings.
 *
 * @param {string[]} arr - The array of strings to be filtered.
 * @returns {string[]} A new array containing only non-empty strings.
 *
 * @example
 * const result = removeEmptyStrings(["hello", "", "world", ""]);
 * console.log(result); // Output: ["hello", "world"]
 */
export function removeEmptyStrings(arr: string[]): string[] {
  return arr.filter((str) => str !== '');
}
